import {createSlice} from '@reduxjs/toolkit';

const initialState = {
  flash: true,
  text: '',
  show: false,
  type: 'error',
  autoHideDuration: 15000,
};

export const messageSlice = createSlice({
  name: 'message',
  initialState,
  reducers: {
    setMessageText: (state, {payload}) => ({
      ...state,
      text: payload,
    }),
    setMessageShow: (state, {payload}) => ({
      ...state,
      show: payload,
    }),
    setMessageType: (state, {payload}) => ({
      ...state,
      type: payload,
    }),
    setMessageIsFlash: (state, {payload}) => ({
      ...state,
      flash: payload,
    }),
    showErrorMessage: (state, {payload}) => ({
      ...state,
      flash: true,
      show: true,
      type: 'error',
      text: payload,
    }),
    showSuccessMessage: (state, {payload}) => ({
      ...state,
      flash: true,
      show: true,
      type: 'success',
      text: payload,
    }),
    showAlertErrorMessage: (state, {payload}) => ({
      ...state,
      flash: false,
      show: true,
      type: 'error',
      text: payload,
    }),
    showAlertSuccessMessage: (state, {payload}) => ({
      ...state,
      flash: false,
      show: true,
      type: 'success',
      text: payload,
    }),
    showMessage: (state, {payload}) => ({
      ...state,
      ...initialState,
      flash: false,
      show: true,
      ...payload,
    }),
  },
});

export const messageState = state => state.message;

export const {
  setMessageText,
  setMessageShow,
  setMessageType,
  setMessageIsFlash,
  showErrorMessage,
  showSuccessMessage,
  showAlertErrorMessage,
  showAlertSuccessMessage,
  showMessage,
} = messageSlice.actions;

export default messageSlice.reducer;
